import { render, staticRenderFns } from "./createResearch.vue?vue&type=template&id=3ad7caad"
import script from "./createResearch.vue?vue&type=script&lang=js"
export * from "./createResearch.vue?vue&type=script&lang=js"
import style0 from "./createResearch.vue?vue&type=style&index=0&id=3ad7caad&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports